// Projeler sayfası alt bileşenlerinin ortak küçük parçaları
export const cls = "w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";

export const statusOptions = [{ value: "Aktif", label: "Aktif" }, { value: "Pasif", label: "Pasif" }];
export const unitOptions = [
  { value: "m²", label: "m²" }, { value: "adet", label: "adet" }, { value: "kişi", label: "kişi" },
  { value: "saat", label: "saat" }, { value: "m³", label: "m³" }, { value: "mt", label: "mt" },
];

// iki tarih arası "3 yıl 1 ay 12 gün" biçiminde süre
export const durationText = (a, b) => {
  if (!a || !b) return "";
  const s = new Date(a), e = new Date(b);
  if (Number.isNaN(s) || Number.isNaN(e) || e < s) return "";
  let y = e.getFullYear() - s.getFullYear(), m = e.getMonth() - s.getMonth(), d = e.getDate() - s.getDate();
  if (d < 0) { m -= 1; d += new Date(e.getFullYear(), e.getMonth(), 0).getDate(); }
  if (m < 0) { y -= 1; m += 12; }
  return [y ? `${y} yıl` : "", m ? `${m} ay` : "", d ? `${d} gün` : ""].filter(Boolean).join(" ") || "0 gün";
};

export function L({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      {children}
    </div>
  );
}

export function StatusSelect({ value, onChange, testid }) {
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className={cls}>
      {statusOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
